/**
 * Application configuration utility
 * Reads from window.APP_CONFIG (loaded from public/config.js)
 * Falls back to environment variables or defaults for local development
 */

// Type definition for window.APP_CONFIG
declare global {
  interface Window {
    APP_CONFIG?: {
      API_BASE_URL?: string;
      REDIRECT_URI?: string;
    };
  }
}

/**
 * Get the API base URL from configuration
 * Priority:
 * 1. window.APP_CONFIG.API_BASE_URL (from config.js)
 * 2. VITE_API_URL (environment variable)
 * 3. Default to localhost for local development
 */
export function getApiBaseUrl(): string {
  // Check runtime config first (loaded from config.js)
  if (window.APP_CONFIG?.API_BASE_URL) {
    return window.APP_CONFIG.API_BASE_URL;
  }

  // Fall back to environment variable (useful for CI/CD)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Default to localhost for local development
  return 'http://localhost:3001';
}

/**
 * Get the redirect URI for authentication
 * Priority:
 * 1. window.APP_CONFIG.REDIRECT_URI (from config.js)
 * 2. VITE_ENTRA_ID_REDIRECT_URI (environment variable)
 * 3. window.location.origin (default - works across all environments)
 */
export function getRedirectUri(): string {
  // Check runtime config first (loaded from config.js)
  if (window.APP_CONFIG?.REDIRECT_URI) {
    return window.APP_CONFIG.REDIRECT_URI;
  }

  // Fall back to environment variable (useful for CI/CD)
  if (import.meta.env.VITE_ENTRA_ID_REDIRECT_URI) {
    return import.meta.env.VITE_ENTRA_ID_REDIRECT_URI;
  }

  // Default to current origin (works across localhost, CloudFront, custom domains)
  return window.location.origin;
}

export const config = {
  getApiBaseUrl,
  getRedirectUri,
};

